import { Auth, API } from "aws-amplify";
import { IBooking, IBookingAgency, IHotel, IUnbookedFlight, IDynamicQuery } from "@vmosolutions/oc-interfaces";
import { openSnackbar } from "../App.Actions";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";

export enum Type {
  GOT_UNBOOKED_FLIGHTS = "GOT_UNBOOKED_FLIGHTS",
  GOT_BOOKINGS = "GOT_BOOKINGS",
  GOT_AGENCIES = "GOT_AGENCIES",
  GOT_HOTELS = "GOT_HOTELS",
  //GOT_UPDATED_BOOKINGS = "GOT_UPDATED_BOOKINGS";
}

export interface IGotUnbookedFlights {
  type: Type.GOT_UNBOOKED_FLIGHTS;
  unbookedFlights: IUnbookedFlight[];
}
export interface IGotBookings {
  type: Type.GOT_BOOKINGS;
  bookings: IBooking[];
}

export interface IGotAgencies {
  type: Type.GOT_AGENCIES;
  agencies: IBookingAgency[];
}

export interface IGotHotels {
  type: Type.GOT_HOTELS;
  hotels: IHotel[];
}

export type Action = IGotUnbookedFlights | IGotBookings | IGotAgencies | IGotHotels;

export const getAgencies = async (): Promise<IBookingAgency[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  const agencies = await API.get("skytrains", "/agency/list", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });
  // Store list of Agencies in Alphabetical order.
  if (Array.isArray(agencies) && agencies?.length > 0) {
    return (agencies as IBookingAgency[]).sort((a, b) => (b.title > a.title ? -1 : 1));
  } else {
    return [];
  }
};

export const gotAgencies = (agencies: IBookingAgency[]): IGotAgencies => {
  return {
    type: Type.GOT_AGENCIES,
    agencies,
  };
};

export const searchBookings = async (searchPayload: IDynamicQuery): Promise<IBooking[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  try {
    const bookings = await API.post("skytrains", "/bookings/search", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: searchPayload,
    });
    return bookings;
  } catch (error) {
    //@ts-ignore
    return error?.response;
  }
};

export const searchBookingErrors = async (searchPayload: IDynamicQuery): Promise<IBooking[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  const start = searchPayload?.queryArgs?.[0]?.value[0];
  const end = searchPayload?.queryArgs?.[0]?.value[1];
  try {
    const bookings = await API.get("skytrains", `/bookings/error?start=${start}&end=${end}`, {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: searchPayload,
    });
    return bookings;
  } catch (error) {
    //@ts-ignore
    return error?.response;
  }
};

export const gotBookings = (bookings: IBooking[]): IGotBookings => {
  return {
    type: Type.GOT_BOOKINGS,
    bookings,
  };
};

export const getHotels = async (): Promise<IHotel[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  const hotels = await API.get("skytrains", "/hotels", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });
  return hotels;
};

export const gotHotels = (hotels: IHotel[]): IGotHotels => {
  return {
    type: Type.GOT_HOTELS,
    hotels,
  };
};

export const deleteBooking = async (
  bookingId: string,
  dispatch: ThunkDispatch<object, object, AnyAction>
): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  dispatch(
    openSnackbar({
      open: true,
      closeDelay: null,
      variant: "info",
      message: "Deleting Selected Booking...",
    })
  );

  const response = await API.del("skytrains", `/booking/${bookingId}`, {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });

  if (response?.deleted) {
    // SUCCESS
    dispatch(
      openSnackbar({
        open: true,
        closeDelay: 3000,
        variant: "success",
        message: response?.message, //"Pairing Successfully Deleted",
      })
    );
  } else {
    // FAILURE
    dispatch(
      openSnackbar({
        open: true,
        closeDelay: 3000,
        variant: "error",
        message: "Something Went Wrong!",
      })
    );
  }
  return response;
};

export const searchUnbookedFlights = async (searchPayload: IDynamicQuery): Promise<IUnbookedFlight[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  try {
    const unbookedFlights = await API.post("skytrains", "/bookings/noBooking", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: searchPayload,
    });
    return unbookedFlights;
  } catch (error) {
    //@ts-ignore
    return error?.response;
  }
};

export const gotUnBookedFlights = (unbookedFlights: IUnbookedFlight[]): IGotUnbookedFlights => {
  return {
    type: Type.GOT_UNBOOKED_FLIGHTS,
    unbookedFlights,
  };
};

export const deleteHotel = async (
  hotelId: string,
  dispatch: ThunkDispatch<object, object, AnyAction>
): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  dispatch(
    openSnackbar({
      open: true,
      closeDelay: null,
      variant: "info",
      message: "Deleting Selected Hotel...",
    })
  );

  const response = await API.del("skytrains", `/hotel/${hotelId}`, {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });

  if (response?.deleted) {
    // SUCCESS
    dispatch(
      openSnackbar({
        open: true,
        closeDelay: 3000,
        variant: "success",
        message: "Hotel Successfully Deleted", //response?.message,
      })
    );
  } else {
    // FAILURE
    dispatch(
      openSnackbar({
        open: true,
        closeDelay: 3000,
        variant: "error",
        message: "Something Went Wrong!",
      })
    );
  }
  return response;
};
